import dayjs from 'dayjs';
import time from 'utils/time';

const DateReplacements = (date) => {
  const today = time().formatCalendarDate();
  const dateReference = time.getCalendarDateKey(date);
  const diff = dayjs(dateReference).diff(dayjs(today), 'day');
  let replacement;
  if (diff === 0) {
    replacement = 'Today';
  } else if (diff === 1) {
    replacement = 'Tomorrow';
  } else if (diff === -1) {
    replacement = 'Yesterday';
  } else {
    replacement = null;
  }
  return replacement;
};

export default DateReplacements;
